import { ITableHead } from '@app/models';
import { TableHeadEnum } from '@app/pages/reports/components/reports.enum';

export const defaultHeadCells: ITableHead[] = [
    {
        id: TableHeadEnum.passwordName,
        label: 'REPORT_MANAGER_USER_PASSWORD_NAME',
        type: 'string'
    },
    {
        id: TableHeadEnum.firstAccessedAt,
        label: 'REPORT_MANAGER_USER_FIRST_ACCESSED_AT',
        type: 'dateTime'
    },
    {
        id: TableHeadEnum.lastAccessedAt,
        label: 'REPORT_MANAGER_USER_LAST_ACCESSED_AT',
        type: 'dateTime'
    },
    {
        id: TableHeadEnum.vaultName,
        label: 'REPORT_MANAGER_USER_VAULT_NAME',
        type: 'string'
    }
];

export const headCellsForUserBeenDoingLately: ITableHead[] = [
    {
        id: TableHeadEnum.passwordName,
        label: 'REPORT_MANAGER_USER_PASSWORD_NAME',
        type: 'string'
    },
    {
        id: TableHeadEnum.happenedAt,
        label: 'REPORT_MANAGER_USER_HAPPENED_AT',
        type: 'dateTime'
    },
    {
        id: TableHeadEnum.type,
        label: 'REPORT_MANAGER_USER_TYPE',
        type: 'string'
    },
    {
        id: TableHeadEnum.vaultName,
        label: 'REPORT_MANAGER_USER_VAULT_NAME',
        type: 'string'
    }
];
